import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import Entities from 'STORE';
import { ClientConfigStoreKey } from 'STORE/ClientConfig/ClientConfig';

export function handleBackgrounds({ backgrounds }: IClientConfigProperty): void {
  Entities.clientConfig.setConfig(ClientConfigStoreKey.Backgrounds, backgrounds);
}
